import React from "react"
import { useRecoilState, useRecoilValue } from "recoil"
import {
  sizeState,
  themeState,
  userObjState,
  editModeState,
} from "../recoil-atom"

import {
  Flex,
  FlexColumn,
  Input,
  Submit,
  DivRound,
} from "../styled-components-openmark"
import { Search as SearchIcon } from "@styled-icons/evaicons-solid"

const Notice = ({ notice }) => {
  const [size, setSize] = useRecoilState(sizeState)
  const [theme, setTheme] = useRecoilState(themeState)
  const [userObj, setUserObj] = useRecoilState(userObjState)
  const [editMode, setEditMode] = useRecoilState(editModeState)

  return (
    <>
      <DivRound
        bgColor={userObj.colors.b0}
        boxShadow={`1px 1px 6px -1px ${userObj.colors.b2}`}
        width={size.appWidth - 10}
        style={{ padding: "13px 20px" }}
      >
        <div
          style={{
            margin: "0 10px",
            overflow: "hidden",
            borderRadius: "10  px",
          }}
        >
          <div className="notice">{notice}</div>
        </div>
      </DivRound>

      <style jsx>{`
        .notice {
          /* width: ${size.appWidth - 10}px; */
          /* margin: 0 20px; */
          font-weight: 300;
          text-align: center;
          white-space: nowrap;
          /* overflow: visible; */
          /* padding-inline-start: -${size.appWidth - 10}px; */
          color: ${theme.f0};
          /* animation: notice ${size.appWidth / 30}s linear infinite; */
        }
        @keyframes notice {
          0% {
            transform: translateX(0px);
            filter: hue-rotate(360deg);
          }
          50% {
            transform: translateX(-${size.appWidth - 10}px);
            filter: hue-rotate(0);
          }
          100% {
            transform: translateX(0px);
            filter: hue-rotate(360deg);
          }
        }
      `}</style>
    </>
  )
}

export default Notice
